import dayjs from "dayjs"

const moment = dayjs

function nestStringProperties(obj) {
  if (!obj) {
    return {}
  }

  const isPlainObject = (obj) => !!obj && obj.constructor === {}.constructor

  const getNestedObject = (obj) =>
    Object.entries(obj).reduce((result, [prop, val]) => {
      prop.split(".").reduce((nestedResult, prop, propIndex, propArray) => {
        const lastProp = propIndex === propArray.length - 1
        if (lastProp) {
          nestedResult[prop] = isPlainObject(val) ? getNestedObject(val) : val
        } else {
          nestedResult[prop] = nestedResult[prop] || {}
        }
        return nestedResult[prop]
      }, result)
      return result
    }, {})

  return getNestedObject(obj)
}

export const processInputData = (inputData) => {
  if (!inputData || !Array.isArray(inputData)) {
    return {}
  }
  const processedData = inputData.reduce((obj, input) => {
    if (input.value !== null) {
      switch (input.inputType) {
        case "number":
          obj[input.userField] = input.value.length
            ? input.value
            : // this is what mysql wants
              null
          break
        case "numberInput":
          obj[input.userField] = input.value
            ? input.value
            : // this is what mysql wants
              null
          break
        case "questionRank":
          obj[input.userField] = input.value
            ? input.value
            : // this is what mysql wants
              null
          break
        case "date":
          obj[input.userField] =
            input.value.length && moment(input.value).isValid()
              ? moment(input.value).format("YYYY-MM-DD")
              : // this is what mysql wants
                null
          break
        default:
          // Prefer full selectedItems when present (e.g., buttonSelection components)
          obj[input.userField] = input.selectedItems ? input.selectedItems : input.value
      }
    }
    return obj
  }, {})

  return nestStringProperties(processedData)
}

const getRecolocationInputValue = (inputData, field) => {
  const value = inputData.find(
    ({ userField }) => userField === `relocations.${field}`
  )?.value

  return value || ""
}

const processPrograms = (page) => (inputData) => {
  if (page !== "relocation") return inputData

  return [
    {
      userField: "relocations",
      value: [
        {
          city: getRecolocationInputValue(inputData, "city1"),
          state: getRecolocationInputValue(inputData, "state1"),
          country: getRecolocationInputValue(inputData, "country1")
        },
        {
          city: getRecolocationInputValue(inputData, "city2"),
          state: getRecolocationInputValue(inputData, "state2"),
          country: getRecolocationInputValue(inputData, "country2")
        },
        {
          city: getRecolocationInputValue(inputData, "city3"),
          state: getRecolocationInputValue(inputData, "state3"),
          country: getRecolocationInputValue(inputData, "country3")
        }
      ]
    }
  ]
}

const runFilledMiddleware = (...funcs) => {
  return (value) => {
    return funcs.reduceRight((acc, func) => {
      return func(acc)
    }, value)
  }
}

export const formatInputData = (inputData, page) =>
  runFilledMiddleware(processPrograms(page))(inputData)

export const processRelocations = () => (inputData) => {
  // Guard against null/undefined inputData
  if (!inputData || typeof inputData !== 'object') {
    return inputData || {}
  }
  
  // Ensure relocations is an array (default to empty array if missing)
  const relocations = Array.isArray(inputData.relocations) 
    ? inputData.relocations 
    : (inputData.relocations ? [inputData.relocations] : [])
  
  const [
    relocationOne = {},
    relocationTwo = {},
    relocationThree = {}
  ] = relocations

  return {
    ...inputData,
    relocations: {
      city1: relocationOne.city,
      state1: relocationOne.state,
      country1: relocationOne.country,
      city2: relocationTwo.city,
      state2: relocationTwo.state,
      country2: relocationTwo.country,
      city3: relocationThree.city,
      state3: relocationThree.state,
      country3: relocationThree.country
    }
  }
}

export const formatIncomingApplication = (inputData) => {
  // Guard against null/undefined inputData
  if (!inputData || typeof inputData !== 'object') {
    console.error('[formatIncomingApplication] Invalid inputData:', inputData)
    return {}
  }
  
  try {
    return runFilledMiddleware(processRelocations())(inputData)
  } catch (error) {
    console.error('[formatIncomingApplication] Error processing application data:', error)
    // Return inputData as-is if processing fails to prevent blank pages
    return inputData || {}
  }
}
